import api from './api';
export const EbayService = {
    searchProducts(query, limit = 10) {
        return api.get('/api/ebay/products', { params: { query, limit } });
    },
    searchOrders(email, limit = 10) {
        return api.get('/api/ebay/orders', { params: { email, limit } });
    },
};
